module.exports = __webpack_public_path__ + "static/media/majorF1.0c3e878.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF1.wav
// module id = WVd4
// module chunks = 0